import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { BookOpen, ArrowRight } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

/** Section 5 — Runner's Knowledge Hub. Renders only once coach-approved articles are published. */
export const KnowledgeHubSection = () => {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    let alive = true;
    axios.get(`${API}/api/public/knowledge/featured`).then((r) => alive && setArticles(Array.isArray(r.data) ? r.data : [])).catch(() => {});
    return () => { alive = false; };
  }, []);
  if (!articles.length) return null;
  return (
    <section id="knowledge-hub" className="max-w-7xl mx-auto px-6 py-16 md:py-20 scroll-mt-20" data-testid="knowledge-hub-section" aria-labelledby="knowledge-heading">
      <div className="mb-10 text-center">
        <div className="text-[10px] uppercase tracking-widest text-[#A855F7] font-black mb-2">Runner’s Knowledge Hub</div>
        <h2 id="knowledge-heading" className="text-3xl md:text-5xl font-black tracking-tight">Learn to Train Smarter</h2>
        <p className="text-muted-foreground mt-3 max-w-2xl mx-auto">Clear, coach-reviewed guides on pace, technique, heart rate, strength and recovery.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {articles.slice(0, 3).map((a) => (
          <Link key={a.slug} to={`/running-knowledge/${a.category}/${a.slug}`} className="group rounded-2xl bg-white border-2 border-[#E5E7EB] hover:border-[#A855F7] hover:shadow-lg transition-all p-6 flex flex-col" data-testid={`knowledge-card-${a.slug}`}>
            <div className="text-[10px] font-black uppercase tracking-widest text-[#7E22CE] mb-2 inline-flex items-center gap-1"><BookOpen size={12} /> {a.category_label || a.category}</div>
            <h3 className="text-lg font-black tracking-tight leading-tight mb-2">{a.title}</h3>
            <p className="text-sm text-slate-600 flex-1 line-clamp-3">{a.summary}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-xs font-black uppercase tracking-widest text-[#7E22CE]">Read <ArrowRight size={12} /></span>
          </Link>
        ))}
      </div>
      <div className="text-center mt-8"><Link to="/running-knowledge" className="inline-flex items-center gap-1 text-xs font-black uppercase tracking-widest text-[#7E22CE] hover:text-[#4C1D95]" data-testid="knowledge-hub-all">Browse the Knowledge Hub <ArrowRight size={12} /></Link></div>
    </section>
  );
};

export default KnowledgeHubSection;
